import createStyles from '@guestyci/foundation/createStyles';
import { ReactComponent as iconGeneralNoteSource } from '@guestyci/icons/IcoGeneralNote.svg';
import Icon from '@guestyci/foundation/Icon';
import cn from 'classnames';

// Default thumb size
const SIZE = '2.2rem';

/**
 * find thumb position in the middle, horizontal
 */
const calculateMiddlePosition = (thumpSize: string) => {
  return `calc((${thumpSize} / 2) + var(--ratio) * 100% - var(--ratio) * ${thumpSize})`;
};

const useClasses = createStyles(() => {
  const sliderThumb = {
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    appearance: 'none',
    backgroundColor: '#F49C4A',
    borderRadius: '50%',
    width: SIZE,
    height: SIZE,
    border: '2px solid white',
    marginLeft: '2px',
  };
  const sliderThumbMax = {
    backgroundColor: '#E75C66',
  };

  return {
    inputRange: {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      width: '100%',
      backgroundImage: 'linear-gradient(270deg, #E75C66 -4.88%, #FABA3C 100%)',
      backgroundRepeat: 'no-repeat',
      background: '#fff',
      backgroundSize: `${calculateMiddlePosition(SIZE)} 100%`,
      borderRadius: '0.625rem',
      height: '1rem',
      border: '2px solid white',

      '&::-webkit-slider-thumb': sliderThumb,
      '&::-moz-range-thumb': sliderThumb,
    },
    primaryBgColorForThumb: {
      '&::-webkit-slider-thumb': sliderThumbMax,
      '&::-moz-range-thumb': sliderThumbMax,
    },
    outputRoot: {
      fontWeight: 500,
      color: 'white',
      fontSize: '1.625rem',
      lineHeight: '1.2',
      position: 'absolute',
      top: '-0.437rem',
      letterSpacing: '-2px',

      width: SIZE,
      height: SIZE,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      left: `${calculateMiddlePosition(SIZE)}`,
    },
    outerInnerItemWrapper: {
      position: 'absolute',
      width: SIZE,
      height: SIZE,
      textAlign: 'center',
      transform: 'translateX(-50%)',
      left: `calc(${SIZE}/-2)`,
      top: `calc(${SIZE}/-2)`,
    },
  };
});

function Range({ value, max }: { value: number; max: number }) {
  const classes = useClasses();

  const daysLeft = max - Math.max(value, 0);
  const isValueMax = value < 0;
  const ratio = daysLeft / max;

  return (
    <div className="relative">
      <input
        type="range"
        className={cn(classes.inputRange, {
          [classes.primaryBgColorForThumb]: isValueMax,
        })}
        min={0}
        max={max}
        value={daysLeft}
        readOnly
        id="rangeInput"
        name="rangeInput"
        style={{ '--ratio': `${ratio}` } as React.CSSProperties}
      />
      <output
        name="amount"
        id="amount"
        htmlFor="rangeInput"
        className={classes.outputRoot}
        style={
          {
            '--ratio': `${ratio}`,
          } as React.CSSProperties
        }
      >
        <div className="relative">
          <div className={classes.outerInnerItemWrapper}>
            {isValueMax ? (
              <Icon svg={iconGeneralNoteSource} width={20} height={20} />
            ) : (
              <span>{value}</span>
            )}
          </div>
        </div>
      </output>
    </div>
  );
}

Range.defaultProps = {
  max: 0,
  value: 0,
};

export default Range;
